import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
 
import { Toaster } from 'react-hot-toast';

import { AuthProvider, useAuth } from './context/AuthContext';
import MainLayout from './components/layout/MainLayout';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import AttendancePage from './pages/AttendancePage';
import AttendanceSummaryPage from './pages/AttendanceSummaryPage';
import FeesPage from './pages/FeesPage';
import StudentPage from './pages/StudentPage';
import CloudChatPage from './pages/CloudChatPage';
import ParentChatPage from './pages/ParentChatPage';
import ClassAnnouncementsPage from './pages/ClassAnnouncementsPage';

// Protected Route component
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#4ade80',
                secondary: '#fff',
              },
            },
            error: {
              duration: 4000,
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          
          <Route path="/" element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="attendance" element={<AttendancePage />} />
            <Route path="attendance-summary" element={<AttendanceSummaryPage />} />
            <Route path="fees" element={<FeesPage />} />
            <Route path="students" element={<StudentPage />} />
            <Route path="calendar" element={<div className="p-6">Calendar Page (Coming Soon)</div>} />
            <Route path="announcements" element={<CloudChatPage />} />
            <Route path="parent-chat" element={<ParentChatPage />} />
            <Route path="class-announcements" element={<ClassAnnouncementsPage />} />
          </Route>
          
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;